import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122809517
export const get_cp_intimacy_mission = createAsyncThunk(
  '/live/facetime/get_cp_intimacy_mission',
  async (e, store: any) => {
    const resp = await http.post('/live/facetime/get_cp_intimacy_mission', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=122809519
export const finish_cp_intimacy_mission = createAsyncThunk(
  '/live/facetime/finish_cp_intimacy_mission',
  async (
    e: {
      mission_id: number
    },
    store: any
  ) => {
    const resp = await http.post('/live/facetime/finish_cp_intimacy_mission', {
      ...store.getState().env.deviceinfo,
      ...e,
    })
    return resp.data.data
  }
)

const initialState: {
  mission_list?: Array<{
    mission_id: number
    completion_count: number
    completion_upperlimit: number
    status: 0 | 1 | 2
    score_award_of_mission: number
    award: {
      'get_award_window ': number
      score_award: number
      score_award_desc: string
      score_award_recieve_title: string
      score_award_recieve_desc: string
    }
    cp_level: number
    mission_desc: '跟任意用户达到CP等级3级'
  }>
} = {}
export const ChatCpActivitySlice = createSlice({
  name: 'ChatCpActivity',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_cp_intimacy_mission.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(finish_cp_intimacy_mission.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default ChatCpActivitySlice.reducer
